export default __webpack_public_path__ + "static/media/9294-degensharpa.25c5d1f6.pdf";